const projects = [
  {
    id: 'motr',
    name: 'MOTR',
    title: 'MOTR operations platform',
    type: 'Automotive operations',
    description:
      'A shared operating view for repair orders, customers, dispatch, payments, parking, and daily shop performance.',
    stack: ['React', 'Xano', 'Operational UX'],
    accent: '#ff6b35',
    accentRgb: '255, 107, 53',
    visual: {
      kind: 'desktop',
      label: 'MOTR HQ',
      images: [
        {
          src: '/assets/portfolio/motr-dashboard.webp',
          alt: 'MOTR operations dashboard showing repair workflow and shop metrics',
        },
      ],
    },
  },
  {
    id: 'tipon',
    name: 'Tipon',
    title: 'Tipon personal finance app',
    type: 'Personal finance product',
    description:
      'A mobile finance product for balances, spending, recurring bills, savings goals, and clear day-by-day review.',
    stack: ['React Native', 'Firebase', 'Financial QA'],
    accent: '#123c72',
    accentRgb: '18, 60, 114',
    visual: {
      kind: 'phones',
      label: 'Tipon mobile',
      images: [
        {
          src: '/assets/portfolio/tipon-calendar.webp',
          alt: 'Tipon calendar showing expenses and recurring transactions',
        },
        {
          src: '/assets/portfolio/tipon-home.webp',
          alt: 'Tipon home dashboard showing balance, savings rate, and recent activity',
        },
        {
          src: '/assets/portfolio/tipon-spending.webp',
          alt: 'Tipon daily spending chart and unpaid expense summary',
        },
      ],
    },
  },
  {
    id: 'foreverstarts',
    name: 'Foreverstarts',
    title: 'Foreverstarts wedding platform',
    type: 'Builder and publishing system',
    description:
      'A wedding-site builder joining templates, content blocks, RSVP flows, publishing, and polished public experiences.',
    stack: ['React', 'Supabase', 'Builder UX'],
    accent: '#245947',
    accentRgb: '36, 89, 71',
    visual: {
      kind: 'desktop',
      label: 'Foreverstarts builder',
      images: [
        {
          src: '/assets/portfolio/foreverstarts-builder.webp',
          alt: 'Foreverstarts wedding website builder with section controls and design presets',
        },
        {
          src: '/assets/portfolio/foreverstarts-landing.webp',
          alt: 'Foreverstarts public landing page',
        },
      ],
    },
  },
  {
    id: 'rentzap',
    name: 'Rentzap',
    title: 'Rentzap revenue reporting',
    type: 'Reporting and analytics',
    description:
      'Provider-level revenue reporting with date filtering, summary metrics, and trend analysis in one operational view.',
    stack: ['Reporting UX', 'Data workflows', 'Charting'],
    accent: '#8d3f90',
    accentRgb: '141, 63, 144',
    visual: {
      kind: 'desktop',
      label: 'Rentzap reporting',
      images: [
        {
          src: '/assets/portfolio/rentzap-reporting.webp',
          alt: 'Rentzap revenue reporting dashboard with provider filters and revenue chart',
        },
      ],
    },
  },
  {
    id: 'onebridge',
    name: 'OneBridge',
    title: 'OneBridge housing operations',
    type: 'Housing operations',
    description:
      'A dashboard for housing teams to monitor properties, applicants, nominations, deal flow, and completion states.',
    stack: ['WeWeb', 'Xano', 'Workflow automation'],
    accent: '#5b4cc4',
    accentRgb: '91, 76, 196',
    visual: {
      kind: 'desktop',
      label: 'OneBridge dashboard',
      images: [
        {
          src: '/assets/portfolio/onebridge-dashboard.webp',
          alt: 'OneBridge housing operations dashboard with property and nomination statistics',
        },
      ],
    },
  },
  {
    id: 'trash-butler',
    name: 'Trash Butler',
    title: 'Trash Butler community operations',
    type: 'Multi-role operations platform',
    description:
      'Support, resident, hazard, RADAR, service, and community workflows across operator and community-facing dashboards.',
    stack: ['Role-based UX', 'Service workflows', 'Reporting'],
    accent: '#1f6fae',
    accentRgb: '31, 111, 174',
    visual: {
      kind: 'desktop',
      label: 'Trash Butler platform',
      images: [
        {
          src: '/assets/portfolio/trash-butler-support.webp',
          alt: 'Trash Butler support desk showing community service tickets',
        },
        {
          src: '/assets/portfolio/community-concierge.webp',
          alt: 'Community Concierge dashboard showing resident and service workflows',
        },
      ],
    },
  },
  {
    id: 'drively',
    name: 'Drively',
    title: 'Drively car rental marketplace',
    type: 'Marketplace experience',
    description:
      'A location-led rental experience for discovering and booking verified vehicles from owners in the local community.',
    stack: ['Marketplace UX', 'Responsive web', 'PWA'],
    accent: '#f97316',
    accentRgb: '249, 115, 22',
    url: 'https://drively.cc/',
    visual: {
      kind: 'desktop',
      label: 'Drively',
      images: [
        {
          src: '/assets/portfolio/drively-landing.webp',
          alt: 'Drively car rental marketplace landing page',
        },
      ],
    },
  },
];

export default projects;
